import { AppMode } from './Generic'

export enum AnalyticsEvent {
  GTM_EVENT_EMMITED = 'GTM_EVENT_EMMITED',
}

export enum AnalyticsAction {
  seen = 'seen',
  completed = 'completed',
  select = 'select',
  appointment_already_taken = 'appointment_already_taken',
  click = 'click',
  gap_booking_attempt = 'gap_booking_attempt',
  add_appointment_to_calendar = 'add_appointment_to_calendar',
}

export enum AnalyticsScreen {
  treatment = 'treatment',
  patientType = 'patient-type',
  bookingFor = 'booking-for',
  practitioner = 'practitioner',
  appointment = 'appointment',
  contactForm = 'contact-form',
  verifyPhoneScreen = 'verify-phone',
  arrivalTime = 'arrival-time',
  insurance = 'insurance',
  appointmentConfirmation = 'appointment-confirmation',
}

export type Event = {
  event: 'D21TrackEvent'
  category: 'form' | 'availy' | AppMode
  label: string
  action: AnalyticsAction
  payload?: Record<string, any>
}
